export default class OKXPrivateClient {
    constructor({ apiKey, secret, passphrase, baseURL = "https://www.okx.com" }) {
        this.apiKey = apiKey
        this.secret = secret
        this.passphrase = passphrase
        this.baseURL = baseURL
        this.encoder = new TextEncoder()
    }

    // ========= 签名 =========
    async _sign(message) {
        const key = await crypto.subtle.importKey(
            "raw",
            this.encoder.encode(this.secret),
            { name: "HMAC", hash: "SHA-256" },
            false,
            ["sign"]
        )

        const sig = await crypto.subtle.sign(
            "HMAC",
            key,
            this.encoder.encode(message)
        )

        return btoa(String.fromCharCode(...new Uint8Array(sig)))
    }

    _getTimestamp() {
        return new Date().toISOString()
    }

    async _request(path, method = "GET", params = {}, signed = false) {
        let queryString = ""
        let body = ""

        // ===== 处理 query =====
        if (method === "GET" && Object.keys(params).length) {
            queryString = "?" + new URLSearchParams(params).toString()
        }

        // ===== 处理 body =====
        if (method !== "GET") {
            body = JSON.stringify(params)
        }

        const fullPath = path + queryString
        const url = this.baseURL + fullPath

        let headers = {
            "Content-Type": "application/json"
        }

        if (signed) {
            const timestamp = this._getTimestamp()

            // ✅ 关键修复点：用 fullPath
            const message = timestamp + method + fullPath + body

            const sign = await this._sign(message)

            headers = {
                ...headers,
                "OK-ACCESS-KEY": this.apiKey,
                "OK-ACCESS-SIGN": sign,
                "OK-ACCESS-TIMESTAMP": timestamp,
                "OK-ACCESS-PASSPHRASE": this.passphrase
            }

            // 👉 强烈建议调试用
            // console.log("message:", message)
        }

        const res = await fetch(url, {
            method,
            headers,
            body: method === "GET" ? undefined : body
        })

        const json = await res.json()

        if (json.code !== "0") {
            throw new Error(json.msg || "OKX API Error")
        }

        return json.data
    }

    // ========= 账户 =========

    // 获取账户信息 / 余额
    getBalance(ccy) {
        return this._request("/api/v5/account/balance", "GET", ccy ? { ccy } : {}, true)
    }

    // 获取持仓信息
    getPositions(instType = "SWAP") {
        return this._request("/api/v5/account/positions", "GET", { instType }, true)
    }

    // ========= 交易 =========

    // 获取全部仓位的委托订单
    getOpenOrders(instType = "SWAP") {
        return this._request("/api/v5/trade/orders-pending", "GET", { instType }, true)
    }

    // ========= 止盈止损 =========

    // 添加止盈止损（附加单）
    orderAlgo(param) {
        return this._request("/api/v5/trade/order-algo", "POST", param, true)
    }

    // 修改止盈止损（修改 Algo 单）
    amendAlgo(param) {
        return this._request("/api/v5/trade/amend-algos", "POST", param, true)
    }

    // 取消止盈止损订单
    cancelAlgos(algoId, instId) {
        return this._request("/api/v5/trade/cancel-algos", "POST", [{ algoId, instId }], true)
    }

    // 获取杠杆信息
    getLeverage(instId, mgnMode = "cross") {
        return this._request("/api/v5/account/leverage-info", "GET", { instId, mgnMode }, true)
    }

    // 设置杠杆
    setLeverage(param) {
        return this._request("/api/v5/account/set-leverage", "POST", param, true)
    }

    // 下单
    placeOrder(param) {
        return this._request("/api/v5/trade/order", "POST", param, true)
    }

    // 市价仓位全平
    closePosition(param) {
        return this._request("/api/v5/trade/order", "POST", param, true)
    }

    //获取历史订单
    getOrderHistory(params) {
        return this._request("/api/v5/trade/orders-history", "GET", params, true)
    }
}
